import { render } from "./RegisterAnswer.vue?vue&type=template&id=f7e157de&scoped=true"
import script from "./RegisterAnswer.vue?vue&type=script&lang=js"
export * from "./RegisterAnswer.vue?vue&type=script&lang=js"

import "./RegisterAnswer.vue?vue&type=style&index=0&id=f7e157de&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7e157de"]])

export default __exports__